import { takeLatest } from "redux-saga/effects";

import { Action } from "../../App/Account/actions";
import * as actions from "../../App/Account/actions";
import { deleteAccount } from "../../App/Account/actions/sagas";

export function* watchDeleteAccount() {
  yield takeLatest(
    Action.DELETE_ACCOUNT,
    deleteAccount({
      onFailure: actions.handleDeleteAccountFailure,
      onSuccess: actions.handleDeleteAccountSuccess,
    })
  );
}
